import { SelectorTypes } from "./Selector.types";
import { IC_ARROW } from "../../../../assets";
import classNames from "classnames";
import "./Selector.scss";

export default function Selector(props: SelectorTypes.Props) {
  const { title, icon, text, link, style, className } = props;

  const onClickHandler = () => {
    window.open(link, "_blank");
  };

  return (
    <div
      onClick={onClickHandler}
      style={style}
      className={classNames("selector", {
        [className || ""]: className,
      })}
    >
      <div className="info">
        <img src={icon} className="img-logo" alt="img-logo" />

        <div>
          <p className="title">{title}</p>
          <p className="text">{text}</p>
        </div>
      </div>

      <img src={IC_ARROW} className="img-arrow" alt="img-arrow" />
    </div>
  );
}
